import { createContext } from 'react';

import { SpotType } from 'constants/enums/SpotTypes';

export const SpotTypeContext = createContext<SpotType>(SpotType.legacy);
